import useCheckout from "hooks/useCheckout";
import ModalSelectDate from "./ModalSelectDate";
import moment from "moment";
import Badge from "shared/Badge/Badge";
import Label from "./Label";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Textarea from "shared/Textarea/Textarea";
import { useTranslation } from "react-i18next";
import { convertHoursToDays } from "utils/convertHoursToDisplayString";
import { Checkbox, FormControlLabel, FormGroup, Grid } from "@mui/material";
import TermsAndCondition from "./TermsAndCondition";

export default function HomeCheckout() {
  const {
    user,
    totalPrice,
    totalHours,
    startTime,
    endTime,
    isCreatingBooking,
    points,
    pointUsed,
    pointInfo,
    userAccountPointBalance,
    isRedeemPointLoading,
    email,
    phone,
    remarks,
    isConfirmTerms,
    isOpenTerms,
    _onEmailChange,
    _onPhoneChange,
    _onRemarksChange,
    setPoints,
    _onRedeemPoint,
    _onCreate,
    _onConfirmTerms,
    _isOpenTerms,
  } = useCheckout();

  const { t } = useTranslation();

  return (
    <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
      <div className="sticky top-28">
        <div className="listingSectionSidebar__wrap shadow-xl">
          {/* PRICE */}
          <div className="flex justify-between">
            <span className="text-3xl font-semibold">{t("checkout_title")}</span>
          </div>

          {/* FORM */}
          <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col flex-row divide-y divide-neutral-200 dark:divide-neutral-700 overflow-hidden z-10">
            <ModalSelectDate
              renderChildren={({ openModal }) => (
                <button className="text-left flex-1 p-5 flex justify-between space-x-5 hover:bg-neutral-50 dark:hover:bg-neutral-800" type="button">
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">{t("startTime")}</span>
                    <span className="mt-1.5 text-lg text-neutral-600">{startTime ? moment(startTime).format("YYYY/MM/DD HH:mm") : "--"}</span>
                  </div>
                </button>
              )}
            />
            <ModalSelectDate
              renderChildren={({ openModal }) => (
                <button className="text-left flex-1 p-5 flex justify-between space-x-5 hover:bg-neutral-50 dark:hover:bg-neutral-800" type="button">
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">{t("endTime")}</span>
                    <span className="mt-1.5 text-lg text-neutral-600"> {endTime ? moment(endTime).format("YYYY/MM/DD HH:mm") : "--"}</span>
                  </div>
                </button>
              )}
            />
            <ModalSelectDate
              renderChildren={({ openModal }) => (
                <button className="text-left flex-1 p-5 flex justify-between space-x-5 hover:bg-neutral-50 dark:hover:bg-neutral-800" type="button">
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">{t("totalTime")}</span>
                    <span className="mt-1.5 text-lg text-neutral-600">{totalHours ? convertHoursToDays(totalHours) : "--"}</span>
                  </div>
                </button>
              )}
            />
            <ModalSelectDate
              renderChildren={({ openModal }) => (
                <button className="text-left flex-1 p-5 flex justify-between space-x-5 hover:bg-neutral-50 dark:hover:bg-neutral-800" type="button">
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">{t("total")}</span>
                    {pointUsed && pointInfo ? (
                      <>
                        <span className="mt-1.5 text-sm text-neutral-300 line-through">{totalPrice ? `HKD $${totalPrice}` : "--"}</span>
                        <span className="mt-1.5 text-lg text-neutral-600 ">{`HKD $${(Number(totalPrice) - Number(pointUsed / pointInfo!["unit_price"] || 1)).toFixed(1)}`}</span>
                        <span>
                          {" "}
                          <Badge color="red" name={`${t("checkout_point_redeem_badge")} ${pointUsed} ${pointInfo!["point_name"]}`} />
                        </span>
                      </>
                    ) : (
                      <span className="mt-1.5 text-lg text-neutral-600">{totalPrice ? `HKD $${totalPrice}` : "--"}</span>
                    )}
                  </div>
                </button>
              )}
            />
          </div>

          {pointInfo && (
            <>
              <h3 className="text-2xl font-semibold">{t("checkout_point_redeem_title")}</h3>
              <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>
              <span className="text-sm text-neutral-600">
                {t("checkout_point_redeem_desc")} {pointInfo!["unit_price"]} {pointInfo!["point_name"]} = 1 HKD
              </span>
              <div className="space-y-2">
                <Label>
                  {t("checkout_point_redeem_label")} ： {userAccountPointBalance} {pointInfo!["point_name"]}
                </Label>
                <div className="flex">
                  <Grid container>
                    <Grid item style={{ marginRight: 5 }}>
                      <Input
                        style={{ height: "100%" }}
                        sizeClass="mr-2"
                        type="number"
                        value={String(points)}
                        onChange={(e) => {
                          setPoints(Number(e.target.value));
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <ButtonPrimary sizeClass="w-[100%] px-5 sm:px-5 py-2 " onClick={_onRedeemPoint} loading={isRedeemPointLoading}>
                        {t("checkout_point_redeem_btn")}
                      </ButtonPrimary>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </>
          )}

          <div>
            <h3 className="text-2xl font-semibold">{t("checkout_contact_title")}</h3>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>
            <div className="mt-6">
              <div className="space-y-1">
                <Label>{t("checkout_contact_email")}</Label>
                <Input
                  type="email"
                  defaultValue={user ? user!["email"] : ""}
                  value={String(email || "")}
                  onChange={(e) => {
                    _onEmailChange(e.target.value);
                  }}
                />
              </div>
              <div className="space-y-1">
                <Label>{t("checkout_contact_phone")}</Label>
                <Input
                  prefix="+852"
                  type="number"
                  defaultValue={user ? user!["phone"] : ""}
                  value={String(phone || "")}
                  onChange={(e) => {
                    _onPhoneChange(e.target.value);
                  }}
                />
              </div>
              <div className="space-y-1">
                <Label>{t("checkout_contact_remarks")}</Label>
                <Textarea
                  value={String(remarks || "")}
                  onChange={(e) => {
                    _onRemarksChange(e.target.value);
                  }}
                />
                <span className="text-sm text-neutral-500 block"></span>
              </div>
            </div>
          </div>

          <FormGroup sx={{ mt: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  value={isConfirmTerms}
                  sx={{
                    color: "grey",
                    "&.Mui-checked": {
                      color: "grey",
                    },
                  }}
                  onChange={(e) => {
                    _onConfirmTerms();
                  }}
                />
              }
              label={
                <span className="text-sm text-neutral-600">
                  {t("checkout_checkbox_desc") + " "}
                  <a style={{ textDecoration: "underline" }} className="text-sm text-neutral-600" onClick={_isOpenTerms}>
                    {t("all_terms")}
                  </a>
                </span>
              }
            />
          </FormGroup>
          <TermsAndCondition isShowModal={isOpenTerms} _onClose={_isOpenTerms} />

          {user ? (
            <ButtonPrimary loading={isCreatingBooking} onClick={_onCreate}>
              {t("checkout_confirm_btn")}
            </ButtonPrimary>
          ) : (
            <ButtonPrimary href="/login">{t("footer_login_now")}</ButtonPrimary>
          )}
        </div>
      </div>
    </div>
  );
}
